import { gql } from '@apollo/client';

export const FETCH_TRAJECTORY_MODEL_CONFIGURATIONS = gql`
    query fetchTrajectoryModelConfigurations($filter: TrajectoryModelFilter) {
        facility {
            models {
                configurations {
                    trajectories(filter: $filter) {
                        id
                        name
                        description
                        type
                        isBlasting
                        calmetConfigurations {
                            id
                            name
                            description
                            sourceForTypes
                            isForecast
                        }
                    }
                }
            }
        }
    }
`;
